import { createFileRoute } from "@tanstack/react-router";
import { alternateLinkList } from "@/lib/i18n/locale";
import { LegalPage, P, UL } from "@/components/marketing/LegalPage";

export const Route = createFileRoute("/legal/retailer-vietnam")({
  head: () => ({
    meta: [
      { title: "Hợp đồng Đại lý Bán lẻ (Việt Nam) — banana.cards" },
      { name: "description", content: "Hợp đồng Đối tác Bán lẻ Banana Cards theo hình thức ký gửi dành cho đại lý tại Việt Nam." },
      { property: "og:title", content: "Hợp đồng Đại lý Bán lẻ (Việt Nam) — banana.cards" },
      { property: "og:description", content: "Ký gửi đơn đầu, đặt cọc 25% hoàn lại, bộ POS miễn phí, biên bán lẻ trên phần cứng và hoa hồng gia hạn phần mềm." },
    ],
    links: alternateLinkList("/legal/retailer-vietnam", "en"),
  }),
  component: RetailerVietnamPage,
});

export function RetailerVietnamPage() {
  return (
    <LegalPage
      eyebrow="Pháp lý · Đối tác"
      title="Hợp đồng"
      italic="Đại lý Bán lẻ."
      updated="Tháng 1, 2026"
      intro="Bán Banana Cards tại cửa hàng của bạn mà không cần bỏ vốn nhập hàng. Đơn đầu tiên theo hình thức ký gửi — chỉ thanh toán khi đã bán được. Nhận bộ POS miễn phí, biên lợi nhuận bán lẻ trên phần cứng và hoa hồng gia hạn 25% trên gói phần mềm."
      related={[
        { label: "Retailer Agreement — Global", to: "/legal/retailer-global" },
        { label: "Affiliate Program — Vietnam", to: "/legal/affiliate-vietnam" },
        { label: "Điều khoản dịch vụ", to: "/terms" },
      ]}
      sections={[
        {
          id: "loiich",
          title: "Lợi ích khi hợp tác",
          body: (
            <>
              <P><strong>Không rủi ro tồn kho.</strong> Đơn hàng đầu tiên được giao theo hình thức Ký gửi — chỉ thanh toán cho sản phẩm đã bán. Hàng chưa bán có thể trả lại hoặc đổi mã hàng khác.</P>
              <P><strong>Chỉ cần đặt cọc 25% (hoàn lại).</strong> Đại lý chỉ cần đặt cọc một lần duy nhất cho đơn ký gửi đầu tiên; các đơn tái nhập sau đó sẽ hoạt động theo hình thức đặt hàng có hoá đơn thông thường.</P>
              <P><strong>Bộ POS đầy đủ miễn phí:</strong> Kệ trưng bày, thẻ mẫu thử, tờ rơi marketing in ấn, đào tạo bán lẻ và kiến thức sản phẩm, kịch bản bán hàng và hướng dẫn xử lý phản đối.</P>
              <P><strong>Biên lợi nhuận bán lẻ hấp dẫn</strong> trên phần cứng theo mô hình mua sỉ áp dụng sau giai đoạn ký gửi ban đầu.</P>
              <P><strong>Hoa hồng 25% gia hạn</strong> trên các gói phần mềm được kích hoạt từ mỗi thẻ bán ra tại cửa hàng — thanh toán vĩnh viễn khi khách còn duy trì gói.</P>
              <P><strong>Không hạn chế độc quyền</strong> — Đại lý có thể bán song song với các dòng sản phẩm khác.</P>
              <P><strong>Hỗ trợ toàn diện về thương hiệu & marketing.</strong> Banana Cards phụ trách thiết kế, sản xuất, mã hoá, nền tảng số, gói đăng ký và chăm sóc người dùng cuối.</P>
              <P><strong>Đặt hàng và tái đặt hàng đơn giản</strong> qua cổng bán sỉ hoặc quản lý tài khoản trực tiếp. Nếu một trong hai bên muốn kết thúc hợp tác, hàng chưa bán có thể trả lại và cọc được hoàn trả (trừ các khoản chưa thanh toán hoặc hàng hư hỏng).</P>
            </>
          ),
        },
        {
          id: "mucdich",
          title: "1. Mục đích",
          body: (
            <P>Hợp đồng này ủy quyền cho Đại lý phân phối các sản phẩm Banana Cards thông qua (các) điểm bán lẻ vật lý của Đại lý theo Mô hình Ký gửi cho đơn hàng đầu tiên, và Mô hình Mua sỉ cho các đơn hàng tiếp theo.</P>
          ),
        },
        {
          id: "quanhe",
          title: "2. Quan hệ Đại lý",
          body: (
            <>
              <P>Đại lý là:</P>
              <UL items={[
                "Đơn vị kinh doanh độc lập",
                "Không phải là nhân viên, bên nhượng quyền, đại diện hoặc chi nhánh của Banana Cards",
                "Không có quyền ràng buộc Banana Cards với bất kỳ hợp đồng hoặc nghĩa vụ nào",
              ]} />
              <P>Không có quyền độc quyền nào được cấp trừ khi có thỏa thuận riêng bằng văn bản.</P>
            </>
          ),
        },
        {
          id: "kygui",
          title: "3. Đơn hàng đầu tiên — Mô hình Ký gửi",
          body: (
            <>
              <P>Đơn hàng đầu tiên các sản phẩm Banana Cards được giao theo hình thức ký gửi. Đại lý chỉ thanh toán cho số lượng sản phẩm thực tế bán được; sản phẩm chưa bán có thể được trả lại trong tình trạng còn kinh doanh được hoặc đổi sang các SKU khác.</P>
              <P><strong>Đặt cọc 25% hoàn lại</strong> được yêu cầu khi đơn ký gửi đầu tiên được vận chuyển — giữ để đảm bảo việc bảo quản sản phẩm, chuyển tiền và toàn vẹn tồn kho, được hoàn trả khi thanh toán đầy đủ hoặc trả lại hàng tồn kho (có khấu trừ đối với đơn vị hư hỏng/mất hoặc khoản chuyển tiền chưa thanh toán).</P>
              <P><strong>Báo cáo:</strong> Yêu cầu báo cáo bán hàng hàng tuần. Thanh toán cho các đơn vị đã bán trong vòng 14 ngày kể từ khi nộp báo cáo.</P>
            </>
          ),
        },
        {
          id: "muasi",
          title: "4. Đơn hàng tiếp theo — Mô hình Mua sỉ",
          body: (
            <>
              <P>Sau khi Đại lý được onboard đầy đủ, các đơn tái nhập tiếp theo hoạt động như đơn mua sỉ thông thường:</P>
              <UL items={[
                "Sản phẩm được mua theo Giá Bán sỉ dành cho Đại lý",
                "Điều khoản thanh toán: trả trước hoặc Net 14, tùy thuộc vào lịch sử giao dịch",
                "Đại lý hưởng biên lợi nhuận bán lẻ (giá bán lẻ trừ giá bán sỉ)",
                "Giá bán sỉ được rà soát hàng năm và có thể thay đổi với thông báo trước 30 ngày",
              ]} />
            </>
          ),
        },
        {
          id: "pos",
          title: "5. Bộ Điểm Bán Lẻ (POS)",
          body: (
            <>
              <P>Banana Cards cung cấp miễn phí:</P>
              <UL items={[
                "Kệ trưng bày để bàn",
                "Thẻ thử nghiệm/demo",
                "Tờ rơi marketing in ấn",
                "Đào tạo bán lẻ và giáo dục sản phẩm",
                "Tài sản marketing (trưng bày trong cửa hàng, mẫu mạng xã hội, v.v.)",
                "Kịch bản bán hàng và hướng dẫn xử lý phản đối",
              ]} />
              <P>Tài liệu vẫn thuộc sở hữu của Banana Cards và phải được trả lại khi chấm dứt.</P>
            </>
          ),
        },
        {
          id: "hoahong",
          title: "6. Hoa hồng Gói phần mềm",
          body: (
            <>
              <P>Với mỗi sản phẩm Banana Cards được bán qua Đại lý và dẫn đến kích hoạt gói đăng ký phần mềm, Đại lý nhận 25% hoa hồng gia hạn trên doanh thu gói phần mềm.</P>
              <UL items={[
                "Hoa hồng được trả vĩnh viễn khi khách còn duy trì gói",
                "Theo dõi tự động qua bản ghi kích hoạt của thẻ đã bán",
                "Hoa hồng được tính không bao gồm VAT",
                "Bản dùng thử, hoàn tiền, chargeback hoặc thanh toán thất bại không phát sinh hoa hồng",
              ]} />
            </>
          ),
        },
        {
          id: "thaydoi-thuongmai",
          title: "6a. Thay đổi tỷ lệ hoa hồng và điều khoản thương mại",
          body: (
            <>
              <P>Banana Cards có quyền cập nhật, sửa đổi, tăng, giảm, thay thế hoặc điều chỉnh tỷ lệ hoa hồng, cấu trúc chiết khấu, quy tắc thanh toán, quy tắc đủ điều kiện, điều khoản đặt cọc hoặc các điều khoản thương mại khác của Chương trình Đại lý theo thời gian.</P>
              <P>Mọi thay đổi như vậy chỉ áp dụng cho khách hàng mới, giao dịch mới, kích hoạt đăng ký mới, đơn hàng mua sỉ mới hoặc doanh số đủ điều kiện mới phát sinh sau ngày có hiệu lực của các điều khoản cập nhật.</P>
              <P>Khách hàng và giao dịch đã được ghi nhận cho Đại lý trước ngày có hiệu lực của bất kỳ thay đổi nào sẽ tiếp tục chịu sự điều chỉnh của tỷ lệ hoa hồng, điều khoản đặt cọc và điều khoản thương mại đã áp dụng tại thời điểm ghi nhận ban đầu, với điều kiện:</P>
              <UL items={[
                "ghi nhận nguồn hợp lệ vẫn tồn tại;",
                "khách hàng vẫn hoạt động và thanh toán;",
                "Đại lý vẫn tuân thủ Hợp đồng này; và",
                "không có gian lận, sử dụng sai, hành vi bị cấm hoặc vi phạm Hợp đồng này xảy ra.",
              ]} />
              <P>Để tránh nghi ngờ, khách hàng và giao dịch hiện có sẽ không tự động chuyển sang tỷ lệ hoa hồng giảm hoặc điều khoản đặt cọc cao hơn chỉ vì Banana Cards thay đổi điều khoản Chương trình Đại lý đối với khách hàng tương lai.</P>
              <P>Banana Cards sẽ thông báo bằng văn bản về bất kỳ thay đổi quan trọng nào đối với tỷ lệ hoa hồng hoặc điều khoản thương mại. Thông báo sẽ ghi rõ ngày có hiệu lực của các điều khoản mới. Việc tiếp tục tham gia Chương trình Đại lý sau ngày có hiệu lực sẽ cấu thành việc chấp nhận các điều khoản cập nhật đối với các giao dịch và doanh số đủ điều kiện trong tương lai.</P>
            </>
          ),
        },
        {
          id: "trachnhiem",
          title: "7. Trách nhiệm Đại lý",
          body: (
            <UL items={[
              "Trưng bày Banana Cards nổi bật trong cửa hàng",
              "Duy trì mức giá bán đã thỏa thuận để bảo vệ toàn vẹn thương hiệu",
              "Nộp báo cáo bán hàng hàng tuần cho hàng ký gửi",
              "Đảm bảo chất lượng sản phẩm (không thấm nước, làm giả, bán lại hàng hư)",
              "Cung cấp thông tin khách hàng chính xác tại điểm bán (khi luật yêu cầu)",
              "Tuân thủ quy định bảo vệ người tiêu dùng và quảng cáo",
            ]} />
          ),
        },
        {
          id: "nghiemcam",
          title: "8. Các hành vi bị nghiêm cấm",
          body: (
            <>
              <P>Đại lý không được:</P>
              <UL items={[
                "Thay đổi, sửa đổi hoặc đóng gói lại sản phẩm Banana Cards",
                "Bán thẻ giả, thẻ nhái hoặc thẻ NFC của bên thứ ba tự xưng tương thích",
                "Bán dưới Giá bán lẻ đề nghị (MSRP) vượt phạm vi khuyến mãi được duyệt",
                "Phân phối hàng ký gửi/mua sỉ cho các bên bán lại khác",
                "Đăng bán hàng ký gửi hoặc mua sỉ trên Shopee, Lazada, TikTok Shop, Amazon hoặc bất kỳ sàn TMĐT nào khi chưa được phê duyệt bằng văn bản",
              ]} />
            </>
          ),
        },
        {
          id: "hoantra",
          title: "9. Trả hàng, đổi hàng & lỗi sản phẩm",
          body: (
            <>
              <P><strong>Hàng ký gửi:</strong> Có thể trả lại trong tình trạng nguyên vẹn trong thời gian ký gửi.</P>
              <P><strong>Lỗi sản xuất:</strong> Được đổi mới miễn phí.</P>
              <P><strong>Hàng hư do Đại lý xử lý:</strong> Không được hoàn tiền.</P>
              <P><strong>Hàng mua sỉ:</strong> Không được trả lại trừ trường hợp có lỗi sản xuất được xác nhận.</P>
            </>
          ),
        },
        {
          id: "chamdut",
          title: "10. Thời hạn & Chấm dứt",
          body: (
            <>
              <P>Có hiệu lực đến khi bất kỳ bên nào chấm dứt bằng thông báo văn bản trước 30 ngày, hoặc chấm dứt ngay lập tức nếu: có khoản chưa thanh toán vượt kỳ hạn thoả thuận, mạo danh thương hiệu, vi phạm hành vi cấm, hoặc đăng bán trái phép trên sàn TMĐT.</P>
              <P><strong>Hệ quả:</strong> Hàng ký gửi chưa bán phải được trả lại trong 14 ngày; cọc hoàn lại được giải ngân sau khi đối soát; bộ POS và tài liệu marketing phải được trả lại hoặc tiêu hủy.</P>
            </>
          ),
        },
        {
          id: "baomat",
          title: "11. Bảo mật",
          body: (
            <P>Mọi thông tin thương mại không công khai — bao gồm giá bán sỉ, mức đặt cọc, dashboard, hợp đồng, dự báo và roadmap — là thông tin bảo mật và không được tiết lộ cho bên thứ ba.</P>
          ),
        },
        {
          id: "trachnhiembt",
          title: "12. Giới hạn trách nhiệm",
          body: (
            <>
              <P>Banana Cards không chịu trách nhiệm cho tổn thất gián tiếp, lợi nhuận mất mát hoặc thiệt hại vượt quá giá trị hoa hồng chưa thanh toán, tiền đặt cọc hoàn lại, hoặc biên lợi nhuận Đại lý chưa thanh toán.</P>
              <P>Đại lý bồi hoàn cho Banana Cards khỏi các khiếu nại phát sinh do sử dụng sai, sơ suất hoặc mạo nhận tại điểm bán hàng.</P>
            </>
          ),
        },
        {
          id: "luat",
          title: "13. Luật áp dụng",
          body: <P>Hợp đồng này được điều chỉnh bởi pháp luật của nước Cộng hòa Xã hội Chủ nghĩa Việt Nam.</P>,
        },
        {
          id: "toanbo",
          title: "14. Toàn bộ Thoả thuận",
          body: (
            <>
              <P>Hợp đồng này cấu thành toàn bộ sự hiểu biết giữa các Bên và thay thế mọi thảo luận hoặc cam kết trước đó liên quan đến Chương trình Đại lý.</P>
              <P>Banana Cards có thể cập nhật điều khoản Chương trình Đại lý theo Mục 6a. Mọi điều khoản cập nhật chỉ áp dụng từ ngày có hiệu lực đã nêu và sẽ không ảnh hưởng đến quyền hoa hồng, quyền đặt cọc hoặc các quyền thương mại khác đã gắn với khách hàng và giao dịch hiện có đã được ghi nhận hợp lệ, trừ khi có thỏa thuận bằng văn bản khác hoặc Đại lý đã vi phạm Hợp đồng này.</P>
            </>
          ),
        },
      ]}
    />
  );
}